import { IRowNode } from "ag-grid-community";
import { IDraftLeg } from "@/store/draftLegsStore";
import { isDraftLegRow } from "./cellRenderers/DraftLeg/useDraftLegTicket";

// LQC-3027 - an edit draft takes its block's place and carries the block's fields, so
// sorts and filters treat it as that block. New legs, and edits whose block is gone, go last.
export function returnCreationGridRows(
  blocks: { id: number }[],
  draftLegs: IDraftLeg[],
  widgetId?: string,
) {
  const toRow = (draftLeg: IDraftLeg, block?: object) => ({
    ...block,
    ...draftLeg,
    rowType: "draft",
    widgetId,
  });
  const editsByBlockId = new Map(
    draftLegs.flatMap((draftLeg) =>
      draftLeg.edit ? [[draftLeg.edit.blockId, draftLeg] as const] : [],
    ),
  );
  const placedIds = new Set<string>();
  const rows = blocks.map((block) => {
    const editDraft = editsByBlockId.get(block.id);
    if (!editDraft) return block;
    placedIds.add(editDraft.id);
    return toRow(editDraft, block);
  });
  const appended = draftLegs
    .filter((draftLeg) => !placedIds.has(draftLeg.id))
    .map((draftLeg) => toRow(draftLeg));
  return [...rows, ...appended];
}

// LQC-2941 - new legs sit above every block whatever the sort, newest first, so they stay together.
// LQC-3027 - edit drafts are left where the sort put them, in their block's place.
// Mutates in place, which is what AG Grid's postSortRows expects.
export function sortNewDraftLegsFirst(nodes: IRowNode[]) {
  const isNewLeg = (node: IRowNode) =>
    isDraftLegRow(node.data) && !node.data.edit;
  // The store appends, so reversing puts the latest "+ Leg" on top.
  const newLegs = nodes.filter(isNewLeg).reverse();
  if (newLegs.length === 0) return;
  const others = nodes.filter((node) => !isNewLeg(node));
  nodes.splice(0, nodes.length, ...newLegs, ...others);
}
